module.exports = __webpack_public_path__ + "static/media/steer.50bc634e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/steer.svg
// module id = 119
// module chunks = 0